import * as React from 'react'
import {
  Edit,
  SimpleForm,
  TextInput,
  required,
  ReferenceInput,
  SelectInput,
  ReferenceArrayInput,
  AutocompleteArrayInput
} from 'react-admin'
import { Box, Typography } from '@mui/material'

const ProviderLocationEdit = (props) => {
  return (
    <Edit {...props} title="Edit Provider Location">
      <SimpleForm>
        <Box width="100%">
          <Typography variant="h6" gutterBottom>Location Details</Typography>
          <Box display="flex" flexDirection="column" gap={2}>
            <TextInput source="locationName" label="Location Name" validate={[required()]} fullWidth />
            <TextInput source="shopifyLocation" label="Shopify Location" fullWidth />
            <ReferenceInput source="providerGroupId" reference="provider-groups" label="Provider Group">
              <SelectInput optionText="name" fullWidth validate={[required()]} />
            </ReferenceInput>
            <ReferenceArrayInput source="providerIds" reference="providers">
              <AutocompleteArrayInput 
                fullWidth 
                optionText="displayName" 
                label="Associated Providers (Doctors)" 
                optionValue="providerId" 
              />
            </ReferenceArrayInput>
          </Box>
        </Box>
      </SimpleForm>
    </Edit>
  )
}

export default ProviderLocationEdit
